export const indent = {
    mobile: '15px',
    heroColumnTablet: '30px',
    heroColumnDesktop: '48px',
}
